import PhaseTask from './phase_task';
import { connect } from 'react-redux';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';

export class SendToFloorWizardPhaseTask extends PhaseTask {
  onClick = () => this.completeTask();
}

export const send_to_floor_wizard = connect(() =>
  ({}), { updatePhaseTask, clearValidationErrors })(SendToFloorWizardPhaseTask);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/send_to_floor_wizard.jsx